import { type ReactElement, type ReactNode } from 'react';
import { EFFECT_CLASS, Z_INDEX } from '@vello/tokens';

/**
 * D550 (ADMIN-A): the stacking shell of an in-app dialog that is not the shared `ConfirmDialog` — the scrim and the centring
 * host at the dialog layer (`Z_INDEX.modal + 2` / `+ 3`, above a drawer and its own scrim). The layer values are tokens and
 * live here, in the theme package, so a screen's dialog (`FormDialog`) needs no `z-index` of its own.
 */
export function DialogLayer({ layerClass, onScrimClick, children }: { readonly layerClass: string; readonly onScrimClick: () => void; readonly children: ReactNode }): ReactElement {
  return (
    <>
      <div className={`vello-scrim ${EFFECT_CLASS.scrim} ${layerClass}`} style={{ zIndex: Z_INDEX.modal + 2 }} onClick={onScrimClick} aria-hidden="true" />
      <div className="vello-dialog-host" style={{ zIndex: Z_INDEX.modal + 3 }}>
        {children}
      </div>
    </>
  );
}
